// 신분류체계정보 관광타입정보 연계 정의서.xlsx 문서를 ai를 활용하여 TS 데이터로 변환했습니다.
export interface TourismContentTypeCode {
  contentTypeId: string;
  multilingualCode: string;
  name: string;
}

export interface TourismClassificationSystem {
  lclsSystm1: string;
  lclsSystm1Name: string;
  lclsSystm2: string;
  lclsSystm2Name: string;
  lclsSystm3: string;
  lclsSystm3Name: string;
  contentTypeId: string;
  multilingualCode: string;
  contentTypeName: string;
}

export interface TourismClassificationSearchParams {
  lclsSystm1?: string;
  lclsSystm2?: string;
  lclsSystm3?: string;
}

export const tourismContentTypeCodes: Record<string, TourismContentTypeCode> = {
  '12': {
    contentTypeId: '12',
    multilingualCode: '76',
    name: '관광지',
  },
  '14': {
    contentTypeId: '14',
    multilingualCode: '78',
    name: '문화시설',
  },
  '15': {
    contentTypeId: '15',
    multilingualCode: '85',
    name: '축제/공연/행사',
  },
  '25': {
    contentTypeId: '25',
    multilingualCode: '-',
    name: '여행코스',
  },
  '28': {
    contentTypeId: '28',
    multilingualCode: '75',
    name: '레포츠',
  },
  '32': {
    contentTypeId: '32',
    multilingualCode: '80',
    name: '숙박',
  },
  '38': {
    contentTypeId: '38',
    multilingualCode: '79',
    name: '쇼핑',
  },
  '39': {
    contentTypeId: '39',
    multilingualCode: '82',
    name: '음식점',
  },
};

export const tourismClassificationSystems: TourismClassificationSystem[] = [
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC01',
    lclsSystm2Name: '호텔',
    lclsSystm3: 'AC010100',
    lclsSystm3Name: '호텔',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC02',
    lclsSystm2Name: '콘도미니엄',
    lclsSystm3: 'AC020100',
    lclsSystm3Name: '콘도',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC02',
    lclsSystm2Name: '콘도미니엄',
    lclsSystm3: 'AC020200',
    lclsSystm3Name: '레지던스',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC03',
    lclsSystm2Name: '펜션/민박',
    lclsSystm3: 'AC030100',
    lclsSystm3Name: '펜션',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC03',
    lclsSystm2Name: '펜션/민박',
    lclsSystm3: 'AC030200',
    lclsSystm3Name: '한옥스테이',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC03',
    lclsSystm2Name: '펜션/민박',
    lclsSystm3: 'AC030300',
    lclsSystm3Name: '농어촌민박',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC03',
    lclsSystm2Name: '펜션/민박',
    lclsSystm3: 'AC030400',
    lclsSystm3Name: '홈스테이',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC04',
    lclsSystm2Name: '모텔',
    lclsSystm3: 'AC040100',
    lclsSystm3Name: '모텔',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC05',
    lclsSystm2Name: '캠핑',
    lclsSystm3: 'AC050100',
    lclsSystm3Name: '일반야영장',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC05',
    lclsSystm2Name: '캠핑',
    lclsSystm3: 'AC050200',
    lclsSystm3Name: '오토캠핑장',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC05',
    lclsSystm2Name: '캠핑',
    lclsSystm3: 'AC050300',
    lclsSystm3Name: '카라반',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC05',
    lclsSystm2Name: '캠핑',
    lclsSystm3: 'AC050400',
    lclsSystm3Name: '글램핑장',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC06',
    lclsSystm2Name: '호스텔',
    lclsSystm3: 'AC060100',
    lclsSystm3Name: '유스호스텔',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'AC',
    lclsSystm1Name: '숙박',
    lclsSystm2: 'AC06',
    lclsSystm2Name: '호스텔',
    lclsSystm3: 'AC060200',
    lclsSystm3Name: '게스트하우스',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV01',
    lclsSystm2Name: '축제',
    lclsSystm3: 'EV010100',
    lclsSystm3Name: '문화관광축제',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV01',
    lclsSystm2Name: '축제',
    lclsSystm3: 'EV010200',
    lclsSystm3Name: '문화예술축제',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV01',
    lclsSystm2Name: '축제',
    lclsSystm3: 'EV010300',
    lclsSystm3Name: '지역특산물축제',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV01',
    lclsSystm2Name: '축제',
    lclsSystm3: 'EV010400',
    lclsSystm3Name: '전통역사축제',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV01',
    lclsSystm2Name: '축제',
    lclsSystm3: 'EV010500',
    lclsSystm3Name: '생태자연축제',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV01',
    lclsSystm2Name: '축제',
    lclsSystm3: 'EV010600',
    lclsSystm3Name: '기타축제',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020100',
    lclsSystm3Name: '전통공연',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020200',
    lclsSystm3Name: '연극',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020300',
    lclsSystm3Name: '뮤지컬',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020400',
    lclsSystm3Name: '오페라',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020500',
    lclsSystm3Name: '무용',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020600',
    lclsSystm3Name: '클래식음악회',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020700',
    lclsSystm3Name: '대중콘서트',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020800',
    lclsSystm3Name: '영화',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV020900',
    lclsSystm3Name: '기타공연',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV02',
    lclsSystm2Name: '공연',
    lclsSystm3: 'EV021000',
    lclsSystm3Name: '넌버벌',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV03',
    lclsSystm2Name: '행사',
    lclsSystm3: 'EV030100',
    lclsSystm3Name: '전시회',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV03',
    lclsSystm2Name: '행사',
    lclsSystm3: 'EV030200',
    lclsSystm3Name: '박람회',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV03',
    lclsSystm2Name: '행사',
    lclsSystm3: 'EV030300',
    lclsSystm3Name: '스포츠경기',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EV',
    lclsSystm1Name: '축제/공연/행사',
    lclsSystm2: 'EV03',
    lclsSystm2Name: '행사',
    lclsSystm3: 'EV030400',
    lclsSystm3Name: '기타행사',
    contentTypeId: '15',
    multilingualCode: '85',
    contentTypeName: '축제/공연/행사',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX01',
    lclsSystm2Name: '전통체험',
    lclsSystm3: 'EX010100',
    lclsSystm3Name: '전통문화체험',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX02',
    lclsSystm2Name: '공예체험',
    lclsSystm3: 'EX020100',
    lclsSystm3Name: '금속공예체험',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX02',
    lclsSystm2Name: '공예체험',
    lclsSystm3: 'EX020200',
    lclsSystm3Name: '유리공예체험',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX02',
    lclsSystm2Name: '공예체험',
    lclsSystm3: 'EX020300',
    lclsSystm3Name: '가죽공예체험',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX02',
    lclsSystm2Name: '공예체험',
    lclsSystm3: 'EX020400',
    lclsSystm3Name: '기타공예체험',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX03',
    lclsSystm2Name: '농.산.어촌 체험',
    lclsSystm3: 'EX030100',
    lclsSystm3Name: '체험마을',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX03',
    lclsSystm2Name: '농.산.어촌 체험',
    lclsSystm3: 'EX030200',
    lclsSystm3Name: '체험목장',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX03',
    lclsSystm2Name: '농.산.어촌 체험',
    lclsSystm3: 'EX030300',
    lclsSystm3Name: '체험농장',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX03',
    lclsSystm2Name: '농.산.어촌 체험',
    lclsSystm3: 'EX030400',
    lclsSystm3Name: '체험어장',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX04',
    lclsSystm2Name: '산사체험',
    lclsSystm3: 'EX040100',
    lclsSystm3Name: '템플스테이',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX04',
    lclsSystm2Name: '산사체험',
    lclsSystm3: 'EX040200',
    lclsSystm3Name: '사찰문화체험',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX05',
    lclsSystm2Name: '웰니스관광',
    lclsSystm3: 'EX050100',
    lclsSystm3Name: '온천 / 사우나 / 스파',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX05',
    lclsSystm2Name: '웰니스관광',
    lclsSystm3: 'EX050200',
    lclsSystm3Name: '찜질방',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX05',
    lclsSystm2Name: '웰니스관광',
    lclsSystm3: 'EX050300',
    lclsSystm3Name: '한방체험',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX05',
    lclsSystm2Name: '웰니스관광',
    lclsSystm3: 'EX050400',
    lclsSystm3Name: '힐링명상',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX05',
    lclsSystm2Name: '웰니스관광',
    lclsSystm3: 'EX050500',
    lclsSystm3Name: '뷰티스파',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX05',
    lclsSystm2Name: '웰니스관광',
    lclsSystm3: 'EX050600',
    lclsSystm3Name: '기타웰니스',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX05',
    lclsSystm2Name: '웰니스관광',
    lclsSystm3: 'EX050700',
    lclsSystm3Name: '자연치유',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX05',
    lclsSystm2Name: '웰니스관광',
    lclsSystm3: 'EX050800',
    lclsSystm3Name: '기타의료관광',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060100',
    lclsSystm3Name: '근대산업유산',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060200',
    lclsSystm3Name: '게임 등 첨단IT산업',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060300',
    lclsSystm3Name: '전통/향토산업',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060400',
    lclsSystm3Name: '문화콘텐츠산업',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060500',
    lclsSystm3Name: '장수기업/산업테마거리',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060600',
    lclsSystm3Name: '자동차/조선/철강 등',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060700',
    lclsSystm3Name: '로봇/항공우주산업',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060800',
    lclsSystm3Name: '화장품/주류/먹거리',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX060900',
    lclsSystm3Name: '친환경/신재생에너지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX06',
    lclsSystm2Name: '산업관광',
    lclsSystm3: 'EX061000',
    lclsSystm3Name: '기타산업관광지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX07',
    lclsSystm2Name: '기타체험',
    lclsSystm3: 'EX070100',
    lclsSystm3Name: '유람선/잠수함관광',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'EX',
    lclsSystm1Name: '체험관광',
    lclsSystm2: 'EX07',
    lclsSystm2Name: '기타체험',
    lclsSystm3: 'EX070200',
    lclsSystm3Name: '기타체험관광',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD01',
    lclsSystm2Name: '한식',
    lclsSystm3: 'FD010100',
    lclsSystm3Name: '관광식당',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD01',
    lclsSystm2Name: '한식',
    lclsSystm3: 'FD010200',
    lclsSystm3Name: '모범음식점',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD02',
    lclsSystm2Name: '외국식',
    lclsSystm3: 'FD020100',
    lclsSystm3Name: '중식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD02',
    lclsSystm2Name: '외국식',
    lclsSystm3: 'FD020200',
    lclsSystm3Name: '일식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD02',
    lclsSystm2Name: '외국식',
    lclsSystm3: 'FD020300',
    lclsSystm3Name: '서양식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD02',
    lclsSystm2Name: '외국식',
    lclsSystm3: 'FD020400',
    lclsSystm3Name: '기타외국식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD02',
    lclsSystm2Name: '외국식',
    lclsSystm3: 'FD020500',
    lclsSystm3Name: '퓨전음식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD03',
    lclsSystm2Name: '간이음식',
    lclsSystm3: 'FD030100',
    lclsSystm3Name: '제과',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD03',
    lclsSystm2Name: '간이음식',
    lclsSystm3: 'FD030200',
    lclsSystm3Name: '피자, 햄버거, 샌드위치 및 유사음식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD03',
    lclsSystm2Name: '간이음식',
    lclsSystm3: 'FD030300',
    lclsSystm3Name: '치킨',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD03',
    lclsSystm2Name: '간이음식',
    lclsSystm3: 'FD030400',
    lclsSystm3Name: '김밥 분식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD03',
    lclsSystm2Name: '간이음식',
    lclsSystm3: 'FD030500',
    lclsSystm3Name: '이동음식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD03',
    lclsSystm2Name: '간이음식',
    lclsSystm3: 'FD030600',
    lclsSystm3Name: '기타간이음식',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD04',
    lclsSystm2Name: '주점',
    lclsSystm3: 'FD040100',
    lclsSystm3Name: '바/펍',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD04',
    lclsSystm2Name: '주점',
    lclsSystm3: 'FD040200',
    lclsSystm3Name: '생맥주전문점',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD04',
    lclsSystm2Name: '주점',
    lclsSystm3: 'FD040300',
    lclsSystm3Name: '클럽',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD04',
    lclsSystm2Name: '주점',
    lclsSystm3: 'FD040400',
    lclsSystm3Name: '전통주/민속주점',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD04',
    lclsSystm2Name: '주점',
    lclsSystm3: 'FD040500',
    lclsSystm3Name: '기타주점',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD05',
    lclsSystm2Name: '카페/ 찻집',
    lclsSystm3: 'FD050100',
    lclsSystm3Name: '카페',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD05',
    lclsSystm2Name: '카페/ 찻집',
    lclsSystm3: 'FD050200',
    lclsSystm3Name: '찻집',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'FD',
    lclsSystm1Name: '음식',
    lclsSystm2: 'FD05',
    lclsSystm2Name: '카페/ 찻집',
    lclsSystm3: 'FD050300',
    lclsSystm3Name: '기타음료점',
    contentTypeId: '39',
    multilingualCode: '82',
    contentTypeName: '음식점',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010100',
    lclsSystm3Name: '고궁',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010200',
    lclsSystm3Name: '성ㆍ산성ㆍ성곽',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010300',
    lclsSystm3Name: '문',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010400',
    lclsSystm3Name: '고택',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010500',
    lclsSystm3Name: '생가',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010600',
    lclsSystm3Name: '민속마을',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010700',
    lclsSystm3Name: '사적지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010800',
    lclsSystm3Name: '고분, 능',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS010900',
    lclsSystm3Name: '사당',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS011000',
    lclsSystm3Name: '선사유적지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS011100',
    lclsSystm3Name: '근대건축물',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS01',
    lclsSystm2Name: '역사유적지',
    lclsSystm3: 'HS011200',
    lclsSystm3Name: '기타역사유적지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS02',
    lclsSystm2Name: '역사유물',
    lclsSystm3: 'HS020100',
    lclsSystm3Name: '탑ㆍ비석ㆍ기념탑',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS02',
    lclsSystm2Name: '역사유물',
    lclsSystm3: 'HS020200',
    lclsSystm3Name: '선사유물',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS02',
    lclsSystm2Name: '역사유물',
    lclsSystm3: 'HS020300',
    lclsSystm3Name: '불상',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS02',
    lclsSystm2Name: '역사유물',
    lclsSystm3: 'HS020400',
    lclsSystm3Name: '기타역사유물',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS03',
    lclsSystm2Name: '종교성지',
    lclsSystm3: 'HS030100',
    lclsSystm3Name: '불교',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS03',
    lclsSystm2Name: '종교성지',
    lclsSystm3: 'HS030200',
    lclsSystm3Name: '기독교',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS03',
    lclsSystm2Name: '종교성지',
    lclsSystm3: 'HS030300',
    lclsSystm3Name: '이슬람',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS03',
    lclsSystm2Name: '종교성지',
    lclsSystm3: 'HS030400',
    lclsSystm3Name: '기타 종교성지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS04',
    lclsSystm2Name: '안보관광지',
    lclsSystm3: 'HS040100',
    lclsSystm3Name: '안보유적지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS04',
    lclsSystm2Name: '안보관광지',
    lclsSystm3: 'HS040200',
    lclsSystm3Name: '안보관광시설',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS04',
    lclsSystm2Name: '안보관광지',
    lclsSystm3: 'HS040300',
    lclsSystm3Name: '북한관광지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'HS',
    lclsSystm1Name: '역사관광',
    lclsSystm2: 'HS04',
    lclsSystm2Name: '안보관광지',
    lclsSystm3: 'HS040400',
    lclsSystm3Name: '기타안보관광지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010100',
    lclsSystm3Name: '인라인(실내 인라인 포함)',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010200',
    lclsSystm3Name: '자전거하이킹',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010300',
    lclsSystm3Name: '카트',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010400',
    lclsSystm3Name: '골프',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010500',
    lclsSystm3Name: '경마',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010600',
    lclsSystm3Name: '경륜',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010700',
    lclsSystm3Name: '승마',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010800',
    lclsSystm3Name: '스키/스노보드',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS010900',
    lclsSystm3Name: '스케이트',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011000',
    lclsSystm3Name: '썰매장',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011100',
    lclsSystm3Name: '수렵장',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011200',
    lclsSystm3Name: '사격장',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011300',
    lclsSystm3Name: '암벽등반',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011400',
    lclsSystm3Name: '서바이벌게임',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011500',
    lclsSystm3Name: 'ATV',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011600',
    lclsSystm3Name: 'MTB',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011700',
    lclsSystm3Name: '오프로드',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011800',
    lclsSystm3Name: '번지점프',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS01',
    lclsSystm2Name: '육상레저스포츠',
    lclsSystm3: 'LS011900',
    lclsSystm3Name: '기타육상레저스포츠',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020100',
    lclsSystm3Name: '윈드서핑/제트스키',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020200',
    lclsSystm3Name: '카약/카누',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020300',
    lclsSystm3Name: '요트',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020400',
    lclsSystm3Name: '스노쿨링/스킨스쿠버다이빙',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020500',
    lclsSystm3Name: '민물낚시',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020600',
    lclsSystm3Name: '바다낚시',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020700',
    lclsSystm3Name: '수영',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020800',
    lclsSystm3Name: '래프팅',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS020900',
    lclsSystm3Name: '수상오토바이',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS021000',
    lclsSystm3Name: '수상자전거',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS021100',
    lclsSystm3Name: '조정',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS021200',
    lclsSystm3Name: '워터슬레드',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS021300',
    lclsSystm3Name: '패러세일',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS02',
    lclsSystm2Name: '수상레저스포츠',
    lclsSystm3: 'LS021400',
    lclsSystm3Name: '기타수상레저스포츠',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS03',
    lclsSystm2Name: '항공레저스포츠',
    lclsSystm3: 'LS030100',
    lclsSystm3Name: '스카이다이빙',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS03',
    lclsSystm2Name: '항공레저스포츠',
    lclsSystm3: 'LS030200',
    lclsSystm3Name: '초경량비행',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS03',
    lclsSystm2Name: '항공레저스포츠',
    lclsSystm3: 'LS030300',
    lclsSystm3Name: '헹글라이딩/패러글라이딩',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS03',
    lclsSystm2Name: '항공레저스포츠',
    lclsSystm3: 'LS030400',
    lclsSystm3Name: '열기구',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS03',
    lclsSystm2Name: '항공레저스포츠',
    lclsSystm3: 'LS030500',
    lclsSystm3Name: '무인비행장치(드론)',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS03',
    lclsSystm2Name: '항공레저스포츠',
    lclsSystm3: 'LS030600',
    lclsSystm3Name: '기타항공레저스포츠',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'LS',
    lclsSystm1Name: '레저스포츠',
    lclsSystm2: 'LS04',
    lclsSystm2Name: '복합레저스포츠',
    lclsSystm3: 'LS040100',
    lclsSystm3Name: '복합레저스포츠',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA01',
    lclsSystm2Name: '자연경관(산)',
    lclsSystm3: 'NA010100',
    lclsSystm3Name: '산, 고개, 오름, 봉우리',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA01',
    lclsSystm2Name: '자연경관(산)',
    lclsSystm3: 'NA010200',
    lclsSystm3Name: '숲',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA01',
    lclsSystm2Name: '자연경관(산)',
    lclsSystm3: 'NA010300',
    lclsSystm3Name: '폭포',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA01',
    lclsSystm2Name: '자연경관(산)',
    lclsSystm3: 'NA010400',
    lclsSystm3Name: '계곡',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA01',
    lclsSystm2Name: '자연경관(산)',
    lclsSystm3: 'NA010500',
    lclsSystm3Name: '약수터',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020100',
    lclsSystm3Name: '강',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020200',
    lclsSystm3Name: '호수',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020300',
    lclsSystm3Name: '저수지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020400',
    lclsSystm3Name: '연못·늪',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020500',
    lclsSystm3Name: '섬',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020600',
    lclsSystm3Name: '염전',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020700',
    lclsSystm3Name: '항구/포구',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020800',
    lclsSystm3Name: '해안절경',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA02',
    lclsSystm2Name: '자연경관(하천‧해양)',
    lclsSystm3: 'NA020900',
    lclsSystm3Name: '해변. 해수욕장',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA03',
    lclsSystm2Name: '자연생태',
    lclsSystm3: 'NA030100',
    lclsSystm3Name: '동굴',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA03',
    lclsSystm2Name: '자연생태',
    lclsSystm3: 'NA030200',
    lclsSystm3Name: '희귀동.식물',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA03',
    lclsSystm2Name: '자연생태',
    lclsSystm3: 'NA030300',
    lclsSystm3Name: '기암괴석',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA03',
    lclsSystm2Name: '자연생태',
    lclsSystm3: 'NA030400',
    lclsSystm3Name: '생태습지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA03',
    lclsSystm2Name: '자연생태',
    lclsSystm3: 'NA030500',
    lclsSystm3Name: '기타자연생태',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA04',
    lclsSystm2Name: '자연공원',
    lclsSystm3: 'NA040100',
    lclsSystm3Name: '국립공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA04',
    lclsSystm2Name: '자연공원',
    lclsSystm3: 'NA040200',
    lclsSystm3Name: '도립공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA04',
    lclsSystm2Name: '자연공원',
    lclsSystm3: 'NA040300',
    lclsSystm3Name: '군립공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA04',
    lclsSystm2Name: '자연공원',
    lclsSystm3: 'NA040400',
    lclsSystm3Name: '지질공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA04',
    lclsSystm2Name: '자연공원',
    lclsSystm3: 'NA040500',
    lclsSystm3Name: '생태관광지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA04',
    lclsSystm2Name: '자연공원',
    lclsSystm3: 'NA040600',
    lclsSystm3Name: '자연휴양림',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA04',
    lclsSystm2Name: '자연공원',
    lclsSystm3: 'NA040700',
    lclsSystm3Name: '수목원ㆍ정원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'NA',
    lclsSystm1Name: '자연관광',
    lclsSystm2: 'NA05',
    lclsSystm2Name: '기타자연관광',
    lclsSystm3: 'NA050100',
    lclsSystm3Name: '기타자연관광',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH01',
    lclsSystm2Name: '백화점',
    lclsSystm3: 'SH010100',
    lclsSystm3Name: '백화점',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH02',
    lclsSystm2Name: '쇼핑몰',
    lclsSystm3: 'SH020100',
    lclsSystm3Name: '복합쇼핑몰',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH02',
    lclsSystm2Name: '쇼핑몰',
    lclsSystm3: 'SH020200',
    lclsSystm3Name: '아웃렛',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH03',
    lclsSystm2Name: '대형마트',
    lclsSystm3: 'SH030100',
    lclsSystm3Name: '대형마트',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH04',
    lclsSystm2Name: '면세점',
    lclsSystm3: 'SH040100',
    lclsSystm3Name: '공항면세점',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH04',
    lclsSystm2Name: '면세점',
    lclsSystm3: 'SH040200',
    lclsSystm3Name: '시내면세점',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH04',
    lclsSystm2Name: '면세점',
    lclsSystm3: 'SH040300',
    lclsSystm3Name: '사후면세점',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH05',
    lclsSystm2Name: '전문매장/상가',
    lclsSystm3: 'SH050100',
    lclsSystm3Name: '공방/공예품점',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH05',
    lclsSystm2Name: '전문매장/상가',
    lclsSystm3: 'SH050200',
    lclsSystm3Name: '전문상가',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH05',
    lclsSystm2Name: '전문매장/상가',
    lclsSystm3: 'SH050300',
    lclsSystm3Name: '관광기념품/특산물판매점',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH06',
    lclsSystm2Name: '시장',
    lclsSystm3: 'SH060100',
    lclsSystm3Name: '비상설시장',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH06',
    lclsSystm2Name: '시장',
    lclsSystm3: 'SH060200',
    lclsSystm3Name: '상설시장',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'SH',
    lclsSystm1Name: '쇼핑',
    lclsSystm2: 'SH07',
    lclsSystm2Name: '기타쇼핑시설',
    lclsSystm3: 'SH070100',
    lclsSystm3Name: '기타쇼핑시설',
    contentTypeId: '38',
    multilingualCode: '79',
    contentTypeName: '쇼핑',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010100',
    lclsSystm3Name: '건물',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010200',
    lclsSystm3Name: '타워 / 전망대',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010300',
    lclsSystm3Name: '다리 / 대교',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010400',
    lclsSystm3Name: '분수',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010500',
    lclsSystm3Name: '동상',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010600',
    lclsSystm3Name: '터널',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010700',
    lclsSystm3Name: '댐',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010800',
    lclsSystm3Name: '등대',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE01',
    lclsSystm2Name: '랜드마크관광',
    lclsSystm3: 'VE010900',
    lclsSystm3Name: '기타 건축/조형물',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE02',
    lclsSystm2Name: '테마공원',
    lclsSystm3: 'VE020100',
    lclsSystm3Name: '테마파크',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE02',
    lclsSystm2Name: '테마공원',
    lclsSystm3: 'VE020200',
    lclsSystm3Name: '워터파크',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE02',
    lclsSystm2Name: '테마공원',
    lclsSystm3: 'VE020300',
    lclsSystm3Name: '동물원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE02',
    lclsSystm2Name: '테마공원',
    lclsSystm3: 'VE020400',
    lclsSystm3Name: '수족관 / 아쿠라리움',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE02',
    lclsSystm2Name: '테마공원',
    lclsSystm3: 'VE020500',
    lclsSystm3Name: '천문대',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE03',
    lclsSystm2Name: '도시공원',
    lclsSystm3: 'VE030100',
    lclsSystm3Name: '시민공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE03',
    lclsSystm2Name: '도시공원',
    lclsSystm3: 'VE030200',
    lclsSystm3Name: '소공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE03',
    lclsSystm2Name: '도시공원',
    lclsSystm3: 'VE030300',
    lclsSystm3Name: '어린이공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE03',
    lclsSystm2Name: '도시공원',
    lclsSystm3: 'VE030400',
    lclsSystm3Name: '근린공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE03',
    lclsSystm2Name: '도시공원',
    lclsSystm3: 'VE030500',
    lclsSystm3Name: '주제공원',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE04',
    lclsSystm2Name: '도시.지역문화관광',
    lclsSystm3: 'VE040100',
    lclsSystm3Name: '골목길, 문화거리',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE04',
    lclsSystm2Name: '도시.지역문화관광',
    lclsSystm3: 'VE040200',
    lclsSystm3Name: '마을관광지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE04',
    lclsSystm2Name: '도시.지역문화관광',
    lclsSystm3: 'VE040300',
    lclsSystm3Name: '둘레길',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE05',
    lclsSystm2Name: '복합관광시설',
    lclsSystm3: 'VE050100',
    lclsSystm3Name: '관광단지',
    contentTypeId: '12',
    multilingualCode: '76',
    contentTypeName: '관광지',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE05',
    lclsSystm2Name: '복합관광시설',
    lclsSystm3: 'VE050200',
    lclsSystm3Name: '리조트',
    contentTypeId: '32',
    multilingualCode: '80',
    contentTypeName: '숙박',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE06',
    lclsSystm2Name: '공연시설',
    lclsSystm3: 'VE060100',
    lclsSystm3Name: '공연장',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE06',
    lclsSystm2Name: '공연시설',
    lclsSystm3: 'VE060200',
    lclsSystm3Name: '영화관',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE07',
    lclsSystm2Name: '전시시설',
    lclsSystm3: 'VE070100',
    lclsSystm3Name: '박물관',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE07',
    lclsSystm2Name: '전시시설',
    lclsSystm3: 'VE070200',
    lclsSystm3Name: '기념관',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE07',
    lclsSystm2Name: '전시시설',
    lclsSystm3: 'VE070300',
    lclsSystm3Name: '전시관',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE07',
    lclsSystm2Name: '전시시설',
    lclsSystm3: 'VE070400',
    lclsSystm3Name: '컨벤션센터',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE07',
    lclsSystm2Name: '전시시설',
    lclsSystm3: 'VE070500',
    lclsSystm3Name: '과학관',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE07',
    lclsSystm2Name: '전시시설',
    lclsSystm3: 'VE070600',
    lclsSystm3Name: '미술관/화랑',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE08',
    lclsSystm2Name: '행사시설',
    lclsSystm3: 'VE080600',
    lclsSystm3Name: '연회장',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE09',
    lclsSystm2Name: '교육시설',
    lclsSystm3: 'VE090100',
    lclsSystm3Name: '한국문화원',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE09',
    lclsSystm2Name: '교육시설',
    lclsSystm3: 'VE090200',
    lclsSystm3Name: '외국문화원',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE09',
    lclsSystm2Name: '교육시설',
    lclsSystm3: 'VE090300',
    lclsSystm3Name: '도서관',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE09',
    lclsSystm2Name: '교육시설',
    lclsSystm3: 'VE090400',
    lclsSystm3Name: '문화전수시설',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE09',
    lclsSystm2Name: '교육시설',
    lclsSystm3: 'VE090500',
    lclsSystm3Name: '어학당',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE09',
    lclsSystm2Name: '교육시설',
    lclsSystm3: 'VE090600',
    lclsSystm3Name: '학교',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE10',
    lclsSystm2Name: '레저스포츠시설',
    lclsSystm3: 'VE100100',
    lclsSystm3Name: '스포츠경기장',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE10',
    lclsSystm2Name: '레저스포츠시설',
    lclsSystm3: 'VE100200',
    lclsSystm3Name: '스포츠센터, 수련시설',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE12',
    lclsSystm2Name: '기타문화관광지',
    lclsSystm3: 'VE120100',
    lclsSystm3Name: '서점',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE12',
    lclsSystm2Name: '기타문화관광지',
    lclsSystm3: 'VE120200',
    lclsSystm3Name: '카지노',
    contentTypeId: '28',
    multilingualCode: '75',
    contentTypeName: '레포츠',
  },
  {
    lclsSystm1: 'VE',
    lclsSystm1Name: '문화관광',
    lclsSystm2: 'VE12',
    lclsSystm2Name: '기타문화관광지',
    lclsSystm3: 'VE120300',
    lclsSystm3Name: '기타문화시설',
    contentTypeId: '14',
    multilingualCode: '78',
    contentTypeName: '문화시설',
  },
  {
    lclsSystm1: 'C01',
    lclsSystm1Name: '추천코스',
    lclsSystm2: 'C0112',
    lclsSystm2Name: '가족코스',
    lclsSystm3: 'C0112001',
    lclsSystm3Name: '가족코스',
    contentTypeId: '25',
    multilingualCode: '-',
    contentTypeName: '여행코스',
  },
  {
    lclsSystm1: 'C01',
    lclsSystm1Name: '추천코스',
    lclsSystm2: 'C0113',
    lclsSystm2Name: '나홀로코스',
    lclsSystm3: 'C0113001',
    lclsSystm3Name: '나홀로코스',
    contentTypeId: '25',
    multilingualCode: '-',
    contentTypeName: '여행코스',
  },
  {
    lclsSystm1: 'C01',
    lclsSystm1Name: '추천코스',
    lclsSystm2: 'C0114',
    lclsSystm2Name: '힐링코스',
    lclsSystm3: 'C0114001',
    lclsSystm3Name: '힐링코스',
    contentTypeId: '25',
    multilingualCode: '-',
    contentTypeName: '여행코스',
  },
  {
    lclsSystm1: 'C01',
    lclsSystm1Name: '추천코스',
    lclsSystm2: 'C0115',
    lclsSystm2Name: '도보코스',
    lclsSystm3: 'C0115001',
    lclsSystm3Name: '도보코스',
    contentTypeId: '25',
    multilingualCode: '-',
    contentTypeName: '여행코스',
  },
  {
    lclsSystm1: 'C01',
    lclsSystm1Name: '추천코스',
    lclsSystm2: 'C0116',
    lclsSystm2Name: '캠핑코스',
    lclsSystm3: 'C0116001',
    lclsSystm3Name: '캠핑코스',
    contentTypeId: '25',
    multilingualCode: '-',
    contentTypeName: '여행코스',
  },
  {
    lclsSystm1: 'C01',
    lclsSystm1Name: '추천코스',
    lclsSystm2: 'C0117',
    lclsSystm2Name: '맛코스',
    lclsSystm3: 'C0117001',
    lclsSystm3Name: '맛코스',
    contentTypeId: '25',
    multilingualCode: '-',
    contentTypeName: '여행코스',
  },
];

export const getTourismContentTypeCode = (
  contentTypeId: string | undefined,
): TourismContentTypeCode => {
  if (!contentTypeId) {
    return {
      contentTypeId: '-',
      multilingualCode: '-',
      name: '콘텐츠 타입 미분류',
    };
  }

  return (
    tourismContentTypeCodes[contentTypeId] ?? {
      contentTypeId,
      multilingualCode: '-',
      name: `기타 (${contentTypeId})`,
    }
  );
};

export const getTourismClassificationSystem = ({
  lclsSystm1,
  lclsSystm2,
  lclsSystm3,
}: TourismClassificationSearchParams): TourismClassificationSystem | null => {
  if (!lclsSystm1 && !lclsSystm2 && !lclsSystm3) {
    return null;
  }

  const exactMatch = tourismClassificationSystems.find((item) =>
    lclsSystm3 ? item.lclsSystm3 === lclsSystm3 : false,
  );

  if (exactMatch) {
    return exactMatch;
  }

  const middleMatch = tourismClassificationSystems.find((item) =>
    lclsSystm2 ? item.lclsSystm2 === lclsSystm2 : false,
  );

  if (middleMatch) {
    return middleMatch;
  }

  return (
    tourismClassificationSystems.find((item) =>
      lclsSystm1 ? item.lclsSystm1 === lclsSystm1 : false,
    ) ?? null
  );
};

export const getTourismClassificationPath = (
  classification: TourismClassificationSystem | null,
): string => {
  if (!classification) {
    return '분류체계 정보 없음';
  }

  return `${classification.lclsSystm1Name} > ${classification.lclsSystm2Name} > ${classification.lclsSystm3Name}`;
};
